import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./InstagramPhoto.scss";

const InstagramPhoto = ({ photos, caption, ...localPhotos }) => {
	// Sometimes we get these at the top level. See: PhotoLiker.jsx
	const pics = photos || localPhotos;

	// Insta's pic urls aren't very reliable, so we're using
	// `original` size until we can get to the bottom of that.
	const picUrl = pics ? pics.original : null;
	const style = picUrl ? { backgroundImage: `url(${picUrl})` } : undefined;

	return (
		<div
			className={classnames("profile-comment-instagram-photo-widget", {
				"profile-comment-instagram-photo-widget--fade": caption,
			})}
			style={style}
		>
			{caption && (
				<span className="profile-comment-instagram-photo-widget-caption">{caption}</span>
			)}
		</div>
	);
};

InstagramPhoto.propTypes = {
	caption: PropTypes.string,
	photos: PropTypes.shape({
		large: PropTypes.string,
		medium: PropTypes.string,
		small: PropTypes.string,
		original: PropTypes.string,
	}),
	original: PropTypes.string,
};

InstagramPhoto.defaultProps = {
	caption: null,
	photos: null,
	original: null,
};

export default InstagramPhoto;



// WEBPACK FOOTER //
// ./src/shared/components/ProfileComment/InstagramPhoto.jsx